import { render } from "./CourseStart.vue?vue&type=template&id=73b8e60a&scoped=true&ts=true"
import script from "./CourseStart.vue?vue&type=script&lang=ts"
export * from "./CourseStart.vue?vue&type=script&lang=ts"

import "./CourseStart.vue?vue&type=style&index=0&id=73b8e60a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b8e60a"],['__file',"src/components/dashbaord/start/CourseStart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73b8e60a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73b8e60a', __exports__)) {
    api.reload('73b8e60a', __exports__)
  }
  
  module.hot.accept("./CourseStart.vue?vue&type=template&id=73b8e60a&scoped=true&ts=true", () => {
    api.rerender('73b8e60a', render)
  })

}


export default __exports__